import type { IProductsWithSoftwarePlan } from 'hooks/useDCSTypes';
import noop from 'lodash/noop';

import type { IAddBundleOptions, ICartModel, IProductModel, IPromoModel, IUpsellModel } from '../models';

export const initialCartModel: ICartModel = {
  productsWithRemovalConflict: [],
  hasDcsError: false,
  cart: {
    cartMetadata: null,
    softwarePlan: null,
    products: [],
    upsell: [],
    orderType: null,
  },
  checkout: {
    count: 0,
    subtotal: 0,
    tax: null,
    promo: {
      program: null,
      applied: null,
    },
    installmentPlans: [],
    softwareTotal: 0,
  },
  hasUrlActionError: false,
  isPricingDataLoading: false,
  byoUpsellItems: [],
};

export interface ICartContextProps extends ICartModel {
  addBundleById: (bundleId: string, options?: IAddBundleOptions) => void;
  addProduct: (product: IUpsellModel) => void;
  addPromo: (promo: IPromoModel) => void;
  emptyCart: () => void;
  removeProductById: (productId: string, force?: boolean) => void;
  removePromo: () => void;
  setTaxRate: (tax: number) => void;
  updateProductQuantityById: (productId: string, quantity: number) => void;
  clearConflicts: () => void;
  addProductsWithSoftwarePlan: (
    productsWithSoftwarePlan: IProductsWithSoftwarePlan,
    accessories: IProductModel[],
    options?: IAddBundleOptions,
  ) => void;
  hasUrlActionError: boolean;
  isPricingDataLoading: boolean;
  setByoUpsellItems: (productModal: IProductModel[]) => void;
}

export const initialCartContext: ICartContextProps = {
  ...initialCartModel,
  addBundleById: noop,
  addProduct: noop,
  addPromo: noop,
  emptyCart: noop,
  removeProductById: noop,
  removePromo: noop,
  setTaxRate: noop,
  updateProductQuantityById: noop,
  clearConflicts: noop,
  addProductsWithSoftwarePlan: noop,
  setByoUpsellItems: noop,
};
